<template>
    <breeze-authenticated-layout>
        <template #header>
            <div class="flex justify-between items-center">
                <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                    User Profile
                </h2>
            </div>
        </template>

        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-sm sm:rounded-lg">
                    <div class="p-6 bg-white border-b border-gray-200">
                        <div class="flex flex-col">
                            <div
                                class="
                                    flex flex-col
                                    md:flex-row
                                    justify-start
                                    items-start
                                    shadow-md
                                    mb-5
                                    p-5
                                "
                            >
                                <ul
                                    class="
                                        flex-1
                                        w-full
                                        flex-shrink-0
                                        order-2
                                        md:order-1
                                    "
                                >
                                    <li
                                        class="
                                            my-2
                                            flex
                                            justify-between
                                            items-center
                                            border-b border-gray-600
                                        "
                                    >
                                        <span class="font-semibold" for=""
                                            >First Name</span
                                        >
                                        <span>{{ user.first_name }}</span>
                                    </li>
                                    <li
                                        class="
                                            my-2
                                            flex
                                            justify-between
                                            items-center
                                            border-b border-gray-600
                                        "
                                    >
                                        <span class="font-semibold" for=""
                                            >Last Name</span
                                        >
                                        <span>{{ user.last_name }}</span>
                                    </li>
                                    <li
                                        class="
                                            my-2
                                            flex
                                            justify-between
                                            items-center
                                            border-b border-gray-600
                                        "
                                    >
                                        <span class="font-semibold" for=""
                                            >Email</span
                                        >
                                        <span>{{ user.email }}</span>
                                    </li>
                                    <li
                                        class="
                                            my-2
                                            flex
                                            justify-between
                                            items-center
                                            border-b border-gray-600
                                        "
                                    >
                                        <span class="font-semibold" for=""
                                            >Country</span
                                        >
                                        <span>{{ user.country ?? "N/A" }}</span>
                                    </li>
                                    <li
                                        class="
                                            my-2
                                            flex
                                            justify-between
                                            items-center
                                            border-b border-gray-600
                                        "
                                    >
                                        <span class="font-semibold" for=""
                                            >City</span
                                        >
                                        <span>{{ user.city ?? "N/A" }}</span>
                                    </li>
                                    <li
                                        class="
                                            my-2
                                            flex
                                            justify-between
                                            items-center
                                            border-b border-gray-600
                                        "
                                    >
                                        <span class="font-semibold" for=""
                                            >Registered at</span
                                        >
                                        <span>{{ user.created_at }}</span>
                                    </li>
                                </ul>
                                <div
                                    class="
                                        flex-1
                                        w-full
                                        flex-shrink-0
                                        order-1
                                        md:order-2
                                        inline-flex
                                        md:justify-end
                                    "
                                >
                                    <img
                                        :src="user.profile_photo_url"
                                        :alt="user.name"
                                        class="
                                            object-cover
                                            w-40
                                            h-40
                                            rounded
                                            shadow
                                        "
                                    />
                                </div>
                            </div>
                            <div
                                class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8"
                            >
                                <div
                                    class="
                                        py-2
                                        align-middle
                                        inline-block
                                        min-w-full
                                        sm:px-6
                                        lg:px-8
                                    "
                                >
                                    <div
                                        class="
                                            shadow
                                            overflow-hidden
                                            border-b border-gray-200
                                            sm:rounded-lg
                                        "
                                    >
                                        <table
                                            class="
                                                min-w-full
                                                divide-y divide-gray-200
                                            "
                                        >
                                            <thead class="bg-gray-50">
                                                <tr>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        #
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        Exercise
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        Coach Name
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        Score
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        Options
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        Created at
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody
                                                class="
                                                    bg-white
                                                    divide-y divide-gray-200
                                                "
                                            >
                                                <tr
                                                    v-for="(
                                                        score, index
                                                    ) in scores"
                                                    :key="index"
                                                >
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                        "
                                                    >
                                                        {{ index + 1 }}
                                                    </td>
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                        "
                                                    >
                                                        {{
                                                            score.exercise.title
                                                        }}
                                                    </td>
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                        "
                                                    >
                                                        {{ score.coach?.name }}
                                                    </td>
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                        "
                                                    >
                                                        {{ score.score }}
                                                    </td>
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                        "
                                                    >
                                                        <div
                                                            class="
                                                                max-w-sm
                                                                max-h-40
                                                                overflow-auto
                                                            "
                                                        >
                                                            <vue-json-pretty
                                                                :path="'res'"
                                                                :data="
                                                                    score.options
                                                                "
                                                            >
                                                            </vue-json-pretty>
                                                        </div>
                                                    </td>
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                        "
                                                    >
                                                        {{ score.created_at }}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </breeze-authenticated-layout>
</template>
<script>
import BreezeAuthenticatedLayout from "@/Layouts/Authenticated";
import axios from "axios";
import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";
export default {
    data() {
        return {
            scores: {},
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            axios
                .get(route("admin.user.exercise", this.user.id))
                .then(({ data }) => {
                    this.scores = data;
                });
        },
    },
    props: {
        user: Array,
    },
    components: {
        BreezeAuthenticatedLayout,
        VueJsonPretty,
    },
};
</script>
